import type { SendRequestType } from '@/lib/utils/shared/httpTools'
import httpTools from '@/lib/utils/shared/httpTools'

type Props = {
  hydraToken: string
}

type PaypalReturnType = {
  token: string
}

export const HydraGetPayPalToken = ({ hydraToken }: Props) => {
  const data = {
    client: 'PayPal',
    namespace: `${process.env.NEXT_PUBLIC_HYDRA_BASE_URL}/transactions`,
    type: 'jwt',
  }

  const request: SendRequestType = {
    method: 'POST',
    url: `/clientTokens?market=US`,
    data,
    token: hydraToken,
  }

  return httpTools.sendRequest<PaypalReturnType>(request)
}
